<template>
  <div class="myNavBar">
    <!-- PC -->
    <nav id="mynavbar-pc">
      <div class="navbar-brand"><img src="./../assets/images/首页/图层1拷贝.png" alt="company-logo" /></div>
      <el-menu class="navbar-tabs" mode="horizontal" background-color="rgba(0,0,0,0)" text-color="#fff" active-text-color="#fff">
        <el-menu-item index="1"><a href="#1">首页</a></el-menu-item>
        <el-menu-item index="2"><a href="#4">商业场景</a></el-menu-item>
        <el-menu-item index="3"><a href="#5">核心技术</a></el-menu-item>
        <el-menu-item index="4"><a href="#6">特殊实力</a></el-menu-item>
        <el-menu-item index="5"><a href="#7">生态落地</a></el-menu-item>
        <el-menu-item index="5"><a href="#13">关于我们</a></el-menu-item>
      </el-menu>
    </nav>
    <!-- mobile -->
    <nav id="mynavbar-mobile">
      <div class="navbar-brand"><img src="./../assets/images/首页/图层1拷贝.png" alt="company-logo" /></div>
      <div class="navbar-tabs">
        <div class="icon-unfold">
          <img src="../assets/images/icon-alert.png" alt="advimg" @click="drawer = true" class="el-icon-s-unfold" />
          <!-- <i ></i> -->
        </div>

        <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :modal="false" direction="ltr" size="260px">
          <div class="el-icon-close"><i @click="drawer = false" class="el-icon-close"></i></div>
          <ul class="menu_list" @click="drawer = false">
            <li class="menu_item" ><a href="#1">首页</a></li>
            <li class="menu_item"><a href="#4">商业场景</a></li>
            <li class="menu_item"><a href="#5">核心技术</a></li>
            <li class="menu_item"><a href="#6">特殊实力</a></li>
            <li class="menu_item"><a href="#7">生态落地</a></li>
            <li class="menu_item"><a href="#13">关于我们</a></li>
          </ul>
        </el-drawer>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      drawer: false
    };
  }
};
</script>

<style lang="less" scoped>
@navbarcolor: transplant;
.myNavBar {
  z-index: 1200;
  width: 100%;
  box-sizing: border-box;
  nav {
    background-color: @navbarcolor;
    position: relative;
    width: 100%;
    height: 27px;
    display: flex;
    justify-content: space-between;

    .navbar-brand {
      display: block;
      float: left;
      img {
        width: 154px;
        height: 27px;
        padding: 18px 0 0 0;
      }
    }
    .navbar-tabs {
      // position: fixed;
      // z-index: 99;
      // left: 10%;
      // width: 40px;
      // height: 40px;
      // background: #000;
      // text-align: center;
      // line-height: 40px;
      position: relative;
      left: -40px;
      top: 10px;
      // transform: translateX(-50%);
      i {
        font-size: 30px;
      }
      .el-icon-close {
        display: block;
        height: 20px;
        width: 20px;
        position: absolute;
        left: 21px;
        top: 18px;
        z-index: 99;
        font-size: 24px;
        i {
          height: 14px;
          width: 15px;
          position: fixed;
          left: 21px;
          top: 21px;
          z-index: 4;
        }
      }
      .menu_list {
        position: fixed;
        background: #fff;
        width: 260px;
        height: 100%;
        right: 0px;
        left: 0px;
        padding-top: 90px;
        z-index: 3;
        .menu_item {
          display: block;
          float: none;
          height: 63px;
          margin-left: 58px;
          color: #2b2e2e;
          a {
            display: block;
            height: 72px;
            line-height: 72px;
            font-size: 16px;
            color: #fff;
            opacity: 0.95;
            position: relative;
            z-index: 2;
            font-weight: normal;
            color: #2b2e2e;
          }
        }
      }
      i {
        color: #fff;
      }
    }
    /* .navbar-tabs {

      // i {
      //   color: #fff;
      // }
    } */
  }
}
@media screen and (max-width: 769px) {
  nav {
    background-color: @navbarcolor;
    position: relative;
    display: flex;

    .navbar-brand {
      position: relative;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      // display: block;
      // float: left;
      img {
        width: 154px;
        height: 27px;
        padding: 18px 0 0 0;
      }
    }
    .navbar-tabs {
      // position: fixed;
      // z-index: 99;
      // left: 10%;
      // width: 40px;
      // height: 40px;
      // background: #000;
      // text-align: center;
      // line-height: 40px;
      position: relative;
      left: -40px;
      top: 10px;
      // transform: translateX(-50%);
      i {
        font-size: 30px;
      }
      .el-icon-close {
        display: block;
        height: 20px;
        width: 20px;
        position: absolute;
        left: 21px;
        top: 18px;
        z-index: 99;
        font-size: 24px;
        i {
          height: 14px;
          width: 15px;
          position: fixed;
          left: 21px;
          top: 21px;
          z-index: 4;
        }
      }
      .menu_list {
        position: fixed;
        background: #fff;
        width: 260px;
        height: 100%;
        right: 0px;
        left: 0px;
        padding-top: 90px;
        z-index: 3;
        .menu_item {
          display: block;
          float: none;
          height: 63px;
          margin-left: 58px;
          color: #2b2e2e;
          a {
            display: block;
            height: 72px;
            line-height: 72px;
            font-size: 16px;
            color: #fff;
            opacity: 0.95;
            position: relative;
            z-index: 2;
            font-weight: normal;
            color: #2b2e2e;
          }
        }
      }
      i {
        color: #fff;
      }
    }
  }
}
@media screen and (max-width: 991px) {
  // mobile & tablet
  .myNavBar {
    position: absolute;
    // position: fixed;
    // background-color: #000;
    padding-left: 5%;
    #mynavbar-pc {
      display: none;
    }
    #mynavbar-mobile {
      .navbar-brand {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
      }
      .navbar-tabs {
        float: right;
        position: fixed;
        z-index: 99;
        left: 0;

        .icon-unfold {
          width: 40px;
          height: 40px;
          background: #000;
          text-align: center;
          line-height: 40px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 992px) {
  // pc
  .myNavBar {
    padding: 0 10%;
    nav {
      .navbar-brand {
        padding-right: 2rem;
      }
    }
    #mynavbar-pc {
      .navbar-tabs {
        float: left;
      }
    }
    #mynavbar-mobile {
      display: none;
    }
  }
  .el-menu-item {
    padding: 0 10px; // tab之间的间距
    a {
      font-size: 16px !important;
    }
  }
}
@media screen and (min-width: 1200px) {
  // large pc
  .el-menu-item {
    padding: 0 20px;
    a {
      font-size: 16px !important;
    }
  }
}
</style>
